import { Link } from "react-router-dom";
import { Logo } from "@/components/Logo";

export default function AuthShell({ title, subtitle, children, footer }) {
  return (
    <div className="mpl-grain flex min-h-screen bg-[#05070D] text-white" style={{ paddingTop: "env(safe-area-inset-top)" }}>
      <div className="relative z-10 mx-auto flex w-full max-w-md flex-col px-5 py-8">
        <Link to="/" className="mb-12" data-testid="auth-home-link"><Logo /></Link>
        <div className="mpl-rise">
          <h1 className="font-display text-4xl font-extrabold uppercase leading-none sm:text-5xl">{title}</h1>
          {subtitle && <p className="mt-3 text-sm text-slate-400">{subtitle}</p>}
          <div className="mt-8">{children}</div>
        </div>
        {footer && <div className="mt-8 text-sm text-slate-400">{footer}</div>}
        <p className="mt-auto pt-12 text-xs text-slate-600">Jeu amical, sans argent. Aucune mise, aucun pari.</p>
      </div>
    </div>
  );
}

export const Field = ({ label, children, hint }) => (
  <label className="block">
    <span className="mb-1.5 block text-xs font-semibold text-slate-300">{label}</span>
    {children}
    {hint && <span className="mt-1 block text-xs text-slate-500">{hint}</span>}
  </label>
);
